// import request from './request';
import { request } from 'root/common/request';
import Config from 'root/common/config/config';

/**
 * 收藏特权
 *
 * @date 2019-07-17
 * @export
 * @param {*} coupon_id
 * @returns
 */
export function privilegeCollect({ coupon_id }) {
    console.log(Config.api.privilegeCollect);
    return request({
        url: Config.api.privilegeCollect,
        params: {
            coupon_id,
        },
    });
}

/**
 * 收藏特权
 *
 * @date 2019-07-17
 * @export
 * @param {*} coupon_id
 * @returns
 */
export function privilegeCancelCollect({ coupon_id }) {
    return request({
        url: Config.api.privilegeCancelCollect,
        params: {
            coupon_id,
        },
    });
}

/**
 * 查看特权状态
 *
 * @date 2019-07-22
 * @export
 * @param {*} { coupon_id }
 * @returns
 */
export function privilegeCollectStatus({ coupon_id }) {
    return request({
        url: Config.api.privilegeCollectStatus,
        params: {
            coupon_id,
        },
    });
}
